import React from 'react';
import { useNavigate } from 'react-router-dom';
import Hero from '@/components/Hero';
import HowItWorks from '@/components/HowItWorks';
import PartnersMarquee from '@/components/PartnersMarquee';
import FeederSpotlight from '@/components/FeederSpotlight';
import OurExpertsSection from '@/components/OurExpertsSection';
import TestimonialsStrip from '@/components/TestimonialsStrip';
import ContactsSection from '@/components/ContactsSection';
import SeoMeta, { organizationJsonLd } from '@/components/SeoMeta';
import { useSignup } from '@/lib/SignupContext';
import { ROUTES } from '@/constants/routes';

export default function Home() {
  const { openSignup } = useSignup();
  const navigate = useNavigate();
  const goCatalogue = () => navigate(ROUTES.catalogue.path);

  return (
    <>
      <SeoMeta
        title="SmartPaw — Pet Store at your door, without extra charge"
        description="Register, tell us the product, quantity and frequency — and relax. Free delivery across Tbilisi. Never run out — we track your stock."
        jsonLd={organizationJsonLd()}
      />
      <Hero onOpenSignup={openSignup} onBrowse={goCatalogue} />
      <HowItWorks onOpenSignup={openSignup} />
      <PartnersMarquee />
      <FeederSpotlight />
      <OurExpertsSection />
      <TestimonialsStrip />
      <ContactsSection />
    </>
  );
}
